import {FirmwareLogicalWidget} from '../firmware-logical-entity';
import {FirmwareLogicalWidgetEnum} from '../../../enums';

export class FirmwareGenericLogicalWidget extends FirmwareLogicalWidget{
  public selected: any = null;


  firmware_logical_widget_type(): FirmwareLogicalWidgetEnum | null {
    return FirmwareLogicalWidgetEnum.FIRMWARE_LOGICAL_WIDGET__GENERIC
  }

  constructor() {
    super();
  } // end constructor
} // end Package
